import React, { useState, useEffect } from 'react';

export default function ComingSoon() {
    const calculateTimeLeft = () => {
        const difference = +new Date('2025-08-10T00:00:00') - +new Date();
        let timeLeft = {};

        if (difference > 0) {
            timeLeft = {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60)
            };
        } else {
            timeLeft = {
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0
            };
        }

        return timeLeft;
    };

    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <div className="min-h-screen pt-[15vh] bg-gradient-to-br from-blue-600 to-indigo-900 flex flex-col items-center justify-center p-6 text-center text-white">
            <div className="max-w-4xl w-full space-y-8">
                <h1 className="text-4xl md:text-6xl font-bold mb-4 animate-pulse">
                    <span className="inline-block transform rotate-12">🚗</span> Transportation Services Coming Soon! <span className="inline-block transform -rotate-12">🚙</span>
                </h1>
                <p className="text-lg md:text-xl font-light text-white/80">
                    We’re still in our early stages and not fully operational yet—but we’re getting there!
                </p>

                <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 md:p-12 shadow-2xl transition-all hover:shadow-yellow-400/30">
                    <h2 className="text-2xl md:text-4xl font-semibold mb-4 text-yellow-400">
                        Limited Time Offer!
                    </h2>
                    <p className="text-lg md:text-xl mb-6">
                        Until then, enjoy our exclusive mobile car wash service while prices last!
                    </p>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
                        {Object.entries(timeLeft).map(([unit, value]) => (
                            <div key={unit} className="bg-white/20 p-4 rounded-xl">
                                <div className="text-3xl font-bold text-yellow-400">{String(value).padStart(2, '0')}</div>
                                <div className="text-sm capitalize">{unit}</div>
                            </div>
                        ))}
                    </div>

                    <button className="bg-yellow-400 text-blue-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-all duration-300 transform hover:scale-105 shadow-lg">
                        <a href='https://www.tmjautospa.com'>Claim Offer Now →</a>
                    </button>
                </div>

                <div className="mt-12 space-y-4">
                    <p className="text-xl md:text-2xl font-light">
                        Stay connected for updates!
                    </p>
                    <div className="flex justify-center space-x-6 text-3xl text-gray-800">
                        <a
                            href="tel:6099686388"
                            className="hover:text-yellow-400 transition-colors"
                            aria-label="Phone"
                        >
                            <i className="fas fa-phone"></i>
                        </a>
                        <a
                            href="mailto:admin@tmjtransport.net"
                            className="hover:text-yellow-400 transition-colors"
                            aria-label="Email"
                        >
                            <i className="fas fa-envelope"></i>
                        </a>
                        <a
                            href="https://www.instagram.com/tmjtransport"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-yellow-400 transition-colors"
                            aria-label="Instagram"
                        >
                            <i className="fab fa-instagram"></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
